<template>
  <VAutocomplete
    v-bind="$attrs"
    v-model="countryId"
    @input="onChange"
    dense
    outlined
    :items="countries"
    item-value="id"
    item-text="name"
    :no-data-text="$t('noCountryFound')"
    autocomplete="disable-city"
    :error-messages="errors['company.countryId']"
    @change="errors['company.countryId'] = null"
  >
    <template v-slot:label>
      {{ $t('country') }} *
    </template>
  </VAutocomplete>
</template>

<script>
import useValidation from '@/compositions/useValidation';
import api from '@/api';
import {
  computed, onMounted, ref, toRefs,
} from '@vue/composition-api';

let countriesCache = null;
let countriesPromise = null;

async function fetchCountries() {
  if (countriesCache) {
    return countriesCache;
  }

  if (!countriesPromise) {
    countriesPromise = api.get('countries')
      .then(({ data }) => {
        countriesCache = (data?.data || []).map((country) => ({
          id: country.id,
          alpha2Code: country.alpha2Code,
          name: country.name,
        }));

        return countriesCache;
      })
      .catch(() => [])
      .finally(() => {
        countriesPromise = null;
      });
  }

  return countriesPromise;
}

export default {
  name: 'AddressCountryInputWithoutFetch',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const current = ref(null);
    const countries = ref([]);

    function onChange(val) {
      const country = countries.value.find((item) => item.id === val);
      emit('input', country?.alpha2Code || null);
    }

    const countryId = computed({
      get() {
        const country = countries.value.find((item) => item.alpha2Code === value.value);
        return country?.id || current.value;
      },
      set(val) {
        current.value = val;
        onChange(val);
      },
    });

    const { errors } = useValidation();

    onMounted(async () => {
      countries.value = await fetchCountries();
    });

    return {
      countries,
      errors,
      countryId,
      onChange,
    };
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
country: Страна
noCountryFound: Не найдено
</i18n>
<i18n lang="yml" locale="en">
country: Country
noCountryFound: Not found
</i18n>
